import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    Cookies.set("cookie_consent", "true", { expires: 365 });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner bg-dark text-white p-3 position-fixed w-100" style={{ bottom: 0, left: 0, zIndex: 9999 }}>
      <div className="d-flex justify-content-between align-items-center container">
        <span>This website uses cookies to ensure you get the best experience.</span>
        <button className="btn btn-sm btn-success" onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
